/**
 * Генерирация и отправка ОТП-кода для подтверждения владения новым номером телефона
 */
export const sendOwnerOTP = (params) => ({
    url: '/claim/confirm-owner/sms',
    method: 'GET',
    params,
});
